import { api } from '../lib/api'
import type { Client, ModelProfile } from '../lib/types'

export interface ClientInput {
  name: string
  googleAccountIds: string[]
  metaAccountIds: string[]
  ga4PropertyId: string | null
  windsorConnector?: string
  metaConversionType: 'leads_messaging' | 'purchases'
  selectedKpis: string[]
  customKpis: string | null
  customPrompt: string | null
  businessContext: string | null
  observatorioNicho?: string | null
  observatorioGeos?: number[]
  // Sites informados (até 5) e páginas fixadas para monitorar (até 10). Lista vazia = nenhum.
  sites?: Array<{ url: string; label: string | null }>
  pinnedPages?: string[]
  modelProfile?: ModelProfile
  contextSummaryWeeks?: number | null
  contextRawWeeks?: number | null
  reportDayOfWeek: number | null
  reportHour: number | null
  priority: number | null
  turno: number | null
  primaryManagerId: string
  backupManagerId: string | null
  active?: boolean
  // Metas opcionais por KPI (só para os KPIs selecionados).
  kpiTargets?: Array<{ metric: string; value: number }>
}

export const clientsApi = {
  list: () => api.get<{ clients: Client[] }>('/clients'),
  get: (id: string) => api.get<{ client: Client }>(`/clients/${id}`),
  create: (data: ClientInput) => api.post<{ client: Client }>('/clients', data),
  update: (id: string, data: Partial<ClientInput>) =>
    api.put<{ client: Client }>(`/clients/${id}`, data),
  remove: (id: string) => api.del<{ ok: true }>(`/clients/${id}`),
}
